import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const EditorialMarquee = () => {
  const { t } = useLanguage();
  return (
    <div data-testid="editorial-marquee" className="bg-cream border-y border-stone py-5 overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {t.marquee.map((item, i) => (
          <span key={i} className="inline-flex items-center gap-8 mr-8">
            <span className="font-serif italic text-xl md:text-2xl text-ink/80 whitespace-nowrap">{item}</span>
            <Asterisk size={18} className="text-citrus" aria-hidden />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
